<template>
  <div class="w-full flex flex-col gap-1">
    <!-- Label -->
    <div v-if="label.length || errorMessage.length" class="w-full flex justify-between items-center">
      <div v-if="label.length" class="flex items-center gap-1.5">
        <BaseText type="label" size="sm" class="text-text-muted">
          {{ label }}
        </BaseText>
        <BaseText v-if="required || optional" type="body" size="xs" class="text-text-subdued">
          {{ required ? ' (required)' : ' (optional)' }}
        </BaseText>
      </div>
      <transition>
        <div v-if="!isValid && errorMessage.length" class="flex items-center gap-0.5">
          <InfoIcon class="text-secondary-red-100" :width="18" :height="18" />
          <BaseText type="body" size="xs" class="text-secondary-red-100">
            {{ errorMessage }}
          </BaseText>
        </div>
      </transition>
    </div>
    <!-- Input -->
    <input :value="inputValue" @input="$emit('update:inputValue', $event.target.value)"
    class="form-input min-w-0 w-full px-2 py-1.5 max-w-none" :class="{'invalid': !isValid}" 
    :placeholder="placeholder" :disabled="disabled" />
  </div>
</template>

<script>
import InfoIcon from './Icons/InfoSimpleIcon.vue'

export default {
  name: 'BaseInputV3',
  components: {
    InfoIcon
  },
  props: {
    inputValue: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    isValid: {
      type: Boolean,
      default: true
    },
    errorMessage: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    optional: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.form-input {
  color: #06070F;
  border-radius: 6px;
  border: 1px solid;
  border-color: transparent;
  box-shadow: 0px 1px 2px 0px rgba(0, 56, 108, 0.08), 0px 0px 0px 1px rgba(0, 56, 108, 0.08);
  transition: border-color 150ms ease-in-out, box-shadow 150ms ease-in-out;

  /* Body/Small */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
}
.form-input:disabled {
  background-color: #F8FAFB;
}
.form-input:focus {
  outline: none;
  box-shadow: 0px 1px 2px 0px rgba(0, 56, 108, 0.1), 0px 0px 0px 1px rgba(0, 56, 108, 0.1);
}
.form-input::placeholder {
  color: #5E6678;
  transition: color 150ms ease-in-out;
  opacity: 0.9;
}
.form-input.invalid {
  box-shadow: none;
  border-color: #FF002F;
}
.form-input:hover::placeholder {
  color: #303546;
}
.form-input:focus::placeholder {
  color: #C1C7D0;
}

.v-enter-active, .v-leave-active {
  transition: opacity 150ms ease-in-out;
}
.v-enter-from, .v-enter, .v-leave-to {
  opacity: 0;
}
.v-enter-to, .v-leave-from {
  opacity: 1;
}
</style>